import styles from "./ChoicePanel.module.scss";

function ReadOnlyChoicePanel() {
  return <div className={styles["panel-empty"]} />;
}

export default ReadOnlyChoicePanel;
